import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {MatIconModule} from "@angular/material/icon";
import {EmbeddedNotificationTypeEnum} from "./enums/embedded-notification-type.enum";

@Component({
	selector: "er-embedded-notification",
	templateUrl: "./embedded-notification.component.html",
	styleUrls: ["./embedded-notification.component.scss"],
	imports: [
		MatIconModule
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class EmbeddedNotificationComponent {

	@Input()
	public notificationTitle?: string;
	@Input()
	public notificationMessage!: string;
	@Input()
	public notificationType!: EmbeddedNotificationTypeEnum;
	@Input()
	public enableActionButton?: boolean;
	@Input()
	public actionButtonText?: string;
	@Output()
	public actionButton: EventEmitter<any> = new EventEmitter<any>();

	protected readonly EmbeddedNotificationType: typeof EmbeddedNotificationTypeEnum = EmbeddedNotificationTypeEnum;

	public onActionButtonClick(event?: any): void {
		if (this.actionButton) {
			this.actionButton.emit(event);
		}
	}
}